import React from 'react';
export function AboutSection() {
  return <section className="bg-light py-28 md:py-32 px-4" data-id="element-11">
      <div className="max-w-[1100px] mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <span className="text-accent font-bold tracking-widest text-sm uppercase block mb-6" data-id="element-14">
            QUIÉN SOY
          </span>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-textDark max-w-3xl mx-auto leading-tight" data-id="element-15">
            Llevo 20 años viendo por dentro lo que a otras nos pasa.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-20" data-id="element-16">
          <div className="w-full rounded-xl overflow-hidden" data-id="element-17">
            <img src="https://cdn.magicpatterns.com/uploads/f3JaajcRJnsVfdaKLLUKrA/Durante_20_anos.jpg" alt="Carolina Gómez" className="w-full h-auto object-cover" data-id="element-18" />
          </div>

          <div className="space-y-6 text-lg md:text-xl text-textDark leading-relaxed" data-id="element-19">
            <p data-id="element-20">
              Durante 20 años corrí en ventas como si trabajar más fuera crecer
              más. Fui vicepresidenta regional en multinacional, viví en 5
              países, ahorré 350.000 dólares. Y lo perdí todo dos veces.
            </p>
            <p data-id="element-21">
              La primera, en un negocio que nos comió el capital entero. La
              segunda, en una pandemia que nos borró 1.500 vendedoras de un mes
              para otro.
            </p>
            <p data-id="element-22">
              Hasta que un día — con mi hija en terapia intensiva y mi familia
              tambaleándose — entendí lo que nadie me había enseñado en dos
              décadas: no me faltaba esfuerzo. Me sobraba carga mal diseñada.
            </p>
            <p data-id="element-23">
              Eso que aprendí lo convertí en método. Desde noviembre de 2025
              acompañé a 260 personas en 7 países (Ecuador, Perú, Colombia,
              Venezuela, Estados Unidos, Argentina y México) a salir del mismo
              lugar donde yo me quedé atrapada. JDON es donde empieza ese
              trabajo.
            </p>
          </div>
        </div>

        <div className="w-full max-w-4xl mx-auto text-center border-t border-gray-200 pt-16" data-id="element-24">
          <p className="font-serif italic text-2xl md:text-4xl text-textDark font-bold leading-tight mb-6" data-id="element-25">
            "No te enseño lo que estudié. Te enseño lo que pagué."
          </p>
          <p className="text-textSecondary text-lg font-medium" data-id="element-26">
            — Carolina Gómez · Estratega de Ventas como Negocio
          </p>
        </div>
      </div>
    </section>;
}